import React from 'react';

export const Attention = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <mask
                id="mask0_2961_34070"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="16"
                height="16"
            >
                <path d="M16 0H0V16H16V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_2961_34070)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.99985 2.13418C4.7598 2.13418 2.13321 4.76077 2.13321 8.00084C2.13321 11.2409 4.7598 13.8675 7.99985 13.8675C11.2399 13.8675 13.8666 11.2409 13.8666 8.00084C13.8666 4.76077 11.2399 2.13418 7.99985 2.13418ZM0.533203 8.00084C0.533203 3.87712 3.87614 0.53418 7.99985 0.53418C12.1236 0.53418 15.4666 3.87712 15.4666 8.00084C15.4666 12.1246 12.1236 15.4675 7.99985 15.4675C3.87614 15.4675 0.533203 12.1246 0.533203 8.00084ZM7.99985 4.53418C8.44169 4.53418 8.79985 4.89235 8.79985 5.33418V8.00084C8.79985 8.44268 8.44169 8.80085 7.99985 8.80085C7.55804 8.80085 7.19987 8.44268 7.19987 8.00084V5.33418C7.19987 4.89235 7.55804 4.53418 7.99985 4.53418ZM7.19987 10.6675C7.19987 10.2257 7.55804 9.86749 7.99985 9.86749H8.00657C8.44833 9.86749 8.80657 10.2257 8.80657 10.6675C8.80657 11.1093 8.44833 11.4675 8.00657 11.4675H7.99985C7.55804 11.4675 7.19987 11.1093 7.19987 10.6675Z"
                    fill="#E04E2A"
                />
            </g>
        </svg>
    );
};
